import { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SearchIcon from "@mui/icons-material/Search";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";

import FloatingSidebar from "../../widgets/Sidebar/FloatingSidebar";
import {
  MANAGE_HOME_NAV_CONFIG,
  MANAGE_HOME_NAV_ITEM_IDS,
} from "../../constants/constants";
import styles from "./ManageHomeLayout.module.scss";

const NAV_ICONS = {
  [MANAGE_HOME_NAV_ITEM_IDS.STUDENT]: SchoolOutlinedIcon,
  [MANAGE_HOME_NAV_ITEM_IDS.AGENT]: PersonOutlineIcon,
};

const SUB_ITEM_ICONS = {
  "student-search": SearchIcon,
  "student-bulk-upload": UploadFileOutlinedIcon,
};

const items = MANAGE_HOME_NAV_CONFIG.map((item) => ({
  ...item,
  icon: NAV_ICONS[item.id],
  subItems: item.subItems?.map((subItem) => ({
    ...subItem,
    icon: SUB_ITEM_ICONS[subItem.id],
  })),
}));

const getActiveNavItemId = (pathname) => {
  if (!pathname) return null;

  const activeItem = items.find((item) => {
    if (!item) return false;
    if (!item.path) return false;
    return pathname.startsWith(item.path);
  });

  if (!activeItem) return null;

  return activeItem.id;
};

const getActiveSubItemId = (pathname) => {
  if (!pathname) return null;

  for (const item of items) {
    if (!Array.isArray(item.subItems) || item.subItems.length === 0) continue;
    if (!pathname.startsWith(item.path)) continue;

    const sortedSubItems = [...item.subItems].sort(
      (a, b) => b.path.length - a.path.length,
    );
    const activeSubItem = sortedSubItems.find(
      (subItem) =>
        pathname === subItem.path ||
        pathname.startsWith(`${subItem.path}/`),
    );

    if (activeSubItem) return activeSubItem.id;
  }

  return null;
};

const ManageHomeLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const activeItemId = getActiveNavItemId(location.pathname);
  const activeSubItemId = getActiveSubItemId(location.pathname);

  const handleItemSelect = (item) => {
    if (!item) return;
    if (!item.path) return;
    if (item.path === location.pathname) return;

    navigate(item.path);
  };

  const handleToggleCollapse = () => {
    setCollapsed((previousCollapsed) => !previousCollapsed);
  };

  return (
    <div className={styles.layout}>
      <FloatingSidebar
        title="Manage"
        items={items}
        activeItemId={activeItemId}
        activeSubItemId={activeSubItemId}
        onItemSelect={handleItemSelect}
        collapsed={collapsed}
        onToggleCollapse={handleToggleCollapse}
      />
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
};

export default ManageHomeLayout;
